
import { Component, Vue } from 'vue-property-decorator';
import SMSRepository from '@/services/SMS';
import SMSRepositoryInterface, { SmsType } from '@/services/SMS/interfaces';
import { WPXFormValue } from '@/components/templates/WPXForm';
import AddServerFrom from '@/services/Server/forms/AddServerFrom';
import AddSmsTemplate from '@/services/SMS/forms/AddSmsTemplate';

@Component({
  inject: ['smsRepository']
})
export default class AddTemplate extends Vue {

  public templateName = ''
  public serverTypes = ['CUSTOM','SYSTEM']
  public selectedType = ''
  public senderName = ''
  public message = ''

  private form: WPXFormValue<AddSmsTemplate> = new WPXFormValue(AddSmsTemplate)
  private readonly smsRepository: SMSRepositoryInterface


  private async addTemplate(): Promise<void> {
    console.log(this.selectedType)
    try {
      await this.smsRepository.createTemplate({
        name: this.templateName,
        smsType: this.selectedType as unknown as SmsType,
        senderName: this.senderName,
        message: this.message,
      })
      this.$successDialog.show(`Template ${this.templateName} has been added`)
    }catch (err) {
      this.$errorDialog.show(err?.response?.data?.message || err.message)
    }
  }
}

